import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { NavBar, DotLoading, Button } from 'antd-mobile'

import { postMessage } from '../../utils'
import { handleClassNames } from '../HOC'

@handleClassNames('l-container flex items-stretch flex-col overflow-hidden')
class Container extends React.PureComponent {
  render () {
    return <div
      {...this.props}
    />
    // return <Flex
    //   align={'stretch'}
    //   direction={'column'}
    //   {...this.props}
    // />
  }
}

// Wrapper.Item = Flex.Item

//  用NavBar代替
@handleClassNames('l-header')
class Header extends React.PureComponent {
  static defaultProps = {
    loading: false,
    ghost: false,
    onBack: function () {
      // window.history.back()
      postMessage({ type: 'back' })
    },
    onClose: function () {
      postMessage({ type: 'close' })
    }
  }
  static propTypes = {
    loading: PropTypes.bool,
    ghost: PropTypes.bool,
    onBack: PropTypes.func,
    onClose: PropTypes.func
  }

  render () {
    const {
      loading,
      ghost,
      onBack,
      onClose,
      className,
      right,
      ...props
    } = this.props
    let classname = classnames(className, { 'l-header--ghost': ghost })
    let rightContent = undefined
    if(process.env['REACT_APP_BUILD_ENV'] === 'development' && !right) {
      rightContent = <div>
        <Button size={'mini'} onClick={() => {
          document.documentElement.setAttribute(
            'data-prefers-color-scheme',
            'dark'
          )
        }}>dark</Button>
        <Button size={'mini'} onClick={() => {
          document.documentElement.setAttribute(
            'data-prefers-color-scheme',
            'light'
          )
        }}>light</Button>
      </div>
    } else {
      rightContent = right
    }
    return <NavBar
      className={classname}
      onBack={onBack}
      left={<div className={'l-header__left'}>
        {/*<div className={'l-header__back'} onClick={onBack}/>*/}
        {/*&emsp;*/}
        {loading && <DotLoading/>}
        {/*<DotLoading/>*/}
        {/*&emsp;<Icon key={'close'} type={'cross'} onClick={onClose} />*/}
      </div>}
      // right={<div>{rightContent}&emsp;<span onClick={onClose}>关闭</span></div>}
      right={rightContent}
      {...props}
    />
  }
}

//  可用TabBar代替
@handleClassNames('l-footer flex items-center')
class Footer extends React.PureComponent {
  render () {
    return <div {...this.props} />
  }
}

// remove 20241121
// Footer.Item = Flex.Item

@handleClassNames('l-wrapper')
class Wrapper extends React.PureComponent {
  static propTypes = {
    flex: PropTypes.bool,
    transparent: PropTypes.bool
  }

  render () {
    const { className, flex, transparent, ...props } = this.props
    return <div
      className={classnames(className, { 'l-wrapper--flex': flex, '!bg-transparent': transparent })}
      {...props}
    />
  }
}

@handleClassNames('l-blank-wrapper flex flex-col items-center justify-center')
class BlankWrapper extends React.PureComponent {
  static propTypes = {
    icon: PropTypes.string

  }

  render () {
    const {
      children,
      icon,
      ...props
    } = this.props
    return <div {...props}>
      {icon ? <i className={`l-blank-wrapper__icon icon-font ${icon}`}/> : null}
      {children}
    </div>
  }
}

export {
  Header,
  Footer,
  Container,
  Wrapper,
  BlankWrapper
}
